export default {
  categories: [],
  category: {},
};
